import React from "react";
import { getColor } from "../util/CC";
import wrap from "../util/wrap";
import CalendarUI from "./helpers/CalendarUI";
import { Button, Col, Divider, Row, Space } from "antd";
import EventUI from "./helpers/EventUI";
import EventViewMore from "../components/components/events/EventViewMore";
import EventSocial from "../components/components/events/EventSocial";
import moment from "moment-timezone";
import { useParams } from "react-router-dom";
export default function Events(props) {


    const { event_filter = "" } = useParams();

    const filterEvents = (_arr) => {

        if (!event_filter) {
            return _arr;
        }

        if (event_filter.length === 8) {
            // date
            
            return _arr.filter((item) => {

                // Exact
                let x = moment(event_filter).format("YYYY MM Do");
                let a = moment(item.from * 1000).format("YYYY MM Do");
                let b = moment(item.to * 1000).format("YYYY MM Do");
                if (x === a && x === b){
                    return true; 
                }               
                return moment(event_filter).isBetween(moment(item.from * 1000).startOf("day").add("-1", "hour"), moment(item.to * 1000).endOf("day"));

            })
        } else {
            // id
            return _arr.filter((item) => {
                return (item.id.toString() === event_filter.toString());
            })
        }

    }


    const template = window.sitesettings.template_info;
    const { content = {} } = props;

    const {
        location = "main",
        component = "blank_space",
        container = true,
        injected_data = [],
        data = {}
    } = content;

    const {
        width = 200,
        background_colour = 0,
        padding_x = 20,
        padding_y = 20,
        title_preset = 0,
        description_preset = 0,
        date_preset = 0,
        button_type = 0,
        button_label = "Buy Books",
        button_align = "left",
        link_id = 0
    } = data;



    const drawButton = (eventData) => {
        const { info = {} } = eventData;
        const { name = "", img_path = "", book = [] } = info;

        if (book.length > 0) {
            return (<>
                {((button_label) && <>
                    <div className="shim" /><div className="shim" />
                    <div style={{ "display": "block", "textAlign": button_align }}>

                        {/* <pre>{JSON.stringify(book, null, 2)}</pre> */}
                        <EventViewMore type="book" data={book} cc_event>
                            <Button className={"bm-btn-" + button_type}>{button_label}</Button>
                        </EventViewMore>

                    </div>

                </>)}
            </>)
        } else {
            return (<></>)
        }
    }

    const drawTicket = (eventData) => {
        const { info = {} } = eventData;
        const { name = "", img_path = "", ticket = [] } = info;

        if (ticket.length > 0) {
            return (<>
                {((button_label) && <>
                    <div className="shim" /><div className="shim" />
                    <div style={{ "display": "block", "textAlign": button_align }}>

                        {/* <pre>{JSON.stringify(book, null, 2)}</pre> */}
                        <EventViewMore type="ticket" data={ticket} cc_event>
                            <Button className={"bm-btn-" + button_type}>Buy Tickets</Button>
                        </EventViewMore>

                    </div>

                </>)}
            </>)
        } else {
            return (<></>)
        }
    }

    const drawEventImages = (eventData) => {


        const { info = {} } = eventData;
        const { name = "", img_path = "", book = [] } = info;

        let book_img = ""
        if (book.length > 0) {
            book_img = "https://cdn1.bookmanager.com/i/m?b=" + book[0].eisbn + "&cb=" + book[0].cover_image_cache
        }

        if (!eventData) {
            return (
                <div style={{ "width": width + "px", "display": "flex", "flexDirection": "column" }}>
                    <img onError={i => i.target.style.display = 'none'} style={{ width: "100%", objectFit: "cover", height: "auto" }} alt={name} src={" https://bookmanager.com/i/sample_content/placeholder.jpg"} />
                </div>
            )
        }

        return (
            <div style={{ "width": width + "px", "display": "flex", "flexDirection": "column" }}>
                {(img_path && <img onError={i => i.target.style.display = 'none'} style={{ width: "100%", objectFit: "cover", height: "auto" }} alt={name} src={img_path} />)}
                {(book_img && <img onError={i => i.target.style.display = 'none'} style={{ width: "100%", objectFit: "cover", height: "auto" }} alt={name} src={book_img} />)}
            </div>
        )


    }




    const drawEvent = (item, index) => {


        const {
            id = "".
                from = 0,
            to = 0,
            info = {}
        } = item;

        const {
            name = "",
            description = "",
            img_path = "",
            book = []
        } = info;

        let _wrapperStyle = {}
        let _bgStyle = {}


        return (
            <div key={item}>

                <div style={_bgStyle}>
                    <div style={_wrapperStyle}>
                        <Row gutter={[20, 40]} className="bm-wrap">
                            <Col flex={(width + "px")}>
                                {drawEventImages(item)}
                                <div>
                                    <EventSocial link_id={link_id} name={name} path={id} />
                                </div>
                            </Col>

                            <Col flex="auto">
                                <EventUI
                                    link_id={link_id}
                                    event_id={id}
                                    title_preset={title_preset}
                                    date_preset={date_preset}
                                    description_preset={description_preset}
                                    event={item} />
                                <div>
                                    <Space size={0}>
                                        {drawButton(item)}
                                        {drawTicket(item)}
                                    </Space>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <div aria-hidden><Divider /></div>
            </div>
        )
    }

    const drawRender = () => {

        let _style = {
            backgroundColor: getColor(background_colour, template),
            padding: padding_y + "px " + padding_x + "px"
        }
        return (
            <div className={(container) ? "preview-container" : ""}>
                <div style={_style}>
                    {filterEvents(injected_data).map((item, index) => {
                        return drawEvent(item, index)
                    })}
                </div>
            </div>
        )
    }


    return drawRender();
}